"use client";
import { Slider } from "@repo/ui";
import Section from "../components/Section";
import LearnerCard from "../components/LearnerCard";
import { useSuspenseQuery } from "@apollo/client";
import { GET_TESTIMONIALS_BY_SLUG } from "@/graphql/queries/testimonials-by-slug-query";
import { useParams } from "next/navigation";

type LearnerSliderProps = {
  data?: TestimonialInterface[];
};
const LearnerSlider = ({ data }: LearnerSliderProps) => {
  return (
    <Slider
      id="learner-slider"
      removeContainerPadding={false}
      removeSliderPadding={true}
      options={{
        breakpoints: {
          "0": {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          "640": {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          "768": {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          "1024": {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          "1170": {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
        },
        navigation: {
          enabled: false,
        },
        pagination: {
          clickable: true,
        },
        slidesPerGroup: 2,
        slidesPerView: 2,
        spaceBetween: 20,
        autoplay: {
          delay: 3000,
          pauseOnMouseEnter: true,
        },
        speed: 5000,
        loop: true,
      }}
      navigationCentered
      navigationCenteredInner={false}
    >
      {data?.map((testimonial) => (
        <LearnerCard
          key={testimonial.id}
          name={testimonial.userName}
          designation={testimonial.jobTitle}
          src={testimonial.avatar_img}
          feedback={testimonial.comments}
        />
      ))}
    </Slider>
  );
};

type WhatOurLearnersAreSayingProps = {
  sectionInfo: PageSections;
  data: {
    buttonAction: string;
    buttonText: string;
    heading: string;
    whatOurLearnersAreSaying: TestimonialInterface[];
  };
};

type Params = {
  country?: string;
  slug?: string;
  course?: string;
  category?: string;
};

const WhatOurLearnersAreSaying = ({
  data,
  sectionInfo,
}: WhatOurLearnersAreSayingProps) => {
  const { country, slug, course, category } = useParams<Params>();

  const { data: testimonialsData } = useSuspenseQuery(
    GET_TESTIMONIALS_BY_SLUG,
    {
      variables: { slug: course || category || slug, country },
    }
  );

  if (!data || !testimonialsData) return null;
  return (
    <Section
      title={data?.heading}
      actionLabel={data?.buttonText}
      path={data.buttonAction}
      id={sectionInfo.sectionId}
      className={`${sectionInfo.sectionClass} bg-primary-main/10`}
    >
      <LearnerSlider
        data={
          data.whatOurLearnersAreSaying.length > 0
            ? data.whatOurLearnersAreSaying
            : testimonialsData.testimonialsBySlug
        }
      />
    </Section>
  );
};

export default WhatOurLearnersAreSaying;
